import React, { useState, useEffect } from 'react'

import { useHistory } from "react-router-dom";
import { Table, Tooltip,Tag, Input, Button, Space,message,Drawer,Modal,
  Statistic, Row, Col,Typography,List, Descriptions
} from 'antd';
import {   
    MenuUnfoldOutlined,
    MenuFoldOutlined,
    UserOutlined,
    VideoCameraOutlined,
    UploadOutlined, 
    DeploymentUnitOutlined,
    SearchOutlined
} from '@ant-design/icons';
import Highlighter from 'react-highlight-words';
import './styles.scss';

import { useDispatch, useSelector, shallowEqual } from 'react-redux'
import moment from 'moment'
import { Bar } from '@ant-design/plots';
import MainPie from '../../analytics/MainPie'
import Column from '../../analytics/Column'
import LineTime from '../../analytics/LineTime'
import ColumnTime from '../../analytics/ColumnTime'
import ColumnGroupTime from '../../analytics/ColumnGroupTime'
import ColumnStackedTime from '../../analytics/ColumnStackedTime'

import {numberWithCommas} from '../../../utils/helpers'

import {fixbrockenpackages} from '../../../Redux/actions/packageActions'

import MainLocationsExport from '../exports/mainLocationsExport'

const { Title } = Typography;


const Index = ({maindata,datePickerValue, hideMoney = false}) => {

  const dispatch = useDispatch()   

  const { crudData,crudDataCount,locations,user,currentProps} = useSelector(
    state => ({
      user: state.auth.user,
      crudData: state.analytics.data,
      crudDataCount: state.analytics.dataCount,
      locations: state.locations.locations,
      currentProps: state.analytics.currentProps,

    }),
    shallowEqual
  )

    const [currentThing, setCurrentThing] = useState(null)
    const [data, setData] = useState(null)
    const [lineItemsFiltered, setLineItemsFiltered] = useState([])

    const [locationSpending, setLocationSpending] = useState([])
    const [locationSpendingGrouped_cat, setLocationSpendingGrouped_cat] = useState([])

    const [categorySpending, setCategorySpending] = useState([])
    const [productspending, setProductSpending] = useState([])
    


    const [shippingSpent, setShippingSpent] = useState(0)

    const [sumSpent, setSumSpent] = useState(0)

    const [categoryFilter, setCategoryFilter] = useState({})
    const [selectedCategory, setSelectedCategory] = useState({})
    


    
    useEffect(() => {		
  
      if(locations && maindata && currentProps){
   
        if(currentProps.apiurl == "packages"){
          getbranchTotals(maindata)
        }

      }
    }, [maindata,locations])

    useEffect(() => {		
        // console.log(selectedCategory)
        // console.log(categoryFilter)


    }, [categoryFilter,selectedCategory])



    const getbranchTotals =()=>{
      var newlocationspending =[]   
  

      var locationCategories =[]    
      var locationProducts=[]    


      var brockenpackages =[]
      var brokenpackages =[]

      var overallitemtotal =0
      var overallshippingtotal =0
      var allcats = []
      var allcatids = []

      var allprods = []
      var allprodids = []

      locations.map(loc=>{   
        var cats = []
        var catids = []

        var prods = []
        var prodids = []

        maindata.map(pk=>{
          if(pk.destination == loc.id){
            pk.items.map(it=>{
              if(it.quantity){
                if(it.regionalization =='international'){
                  if(it.cost_rmb_adjusted == undefined){
                    console.log(`no rmb adjusted ${pk.id} - ${it.id}`)
                    if(!brockenpackages.includes(pk.id)){
                      brockenpackages.push(pk.id)
                      brokenpackages.push(pk)
                    }
                  }
                 
                }else{
                  if(it.cost_peso == undefined){
                    console.log(`no peso ${pk.id} - ${it.id}`)
                    if(!brockenpackages.includes(pk.id)){
                      brockenpackages.push(pk.id)
                      brokenpackages.push(pk)
                    }
                  }
                 
                }
     
              }
              if(it.category){
                if(!catids.includes(it.category)){
                  catids.push(it.category)
                  var newcat={
                    cat_id:it.category,
                    cat_name:it.category_name,
                    cat_total:0
                  }
                  cats.push(newcat)                
                }
                if(!allcatids.includes(it.category)){
                  allcatids.push(it.category)
                  var newcat={
                    cat_id:it.category,
                    cat_name:it.category_name,
                    cat_total:0
                  }
                  allcats.push(newcat)                
                }
                if(!prodids.includes(it.product) && it.quantity > 0){
                  prodids.push(it.product)
                  var newrprod={      
                    category:it.category,
                    category_name:it.category_name,         
                    product: it.product,
                    product_name: it.product_name,
                    regionalization: it.regionalization,
                    unit: it.unit,
                    quantity: 0,
                    total:0                  
                  }
                  prods.push(newrprod)                
                }
                if(!allprodids.includes(it.product)  && it.quantity > 0){
                  allprodids.push(it.product)
                  var newrprod={        
                    category:it.category,
                    category_name:it.category_name,       
                    product: it.product,
                    product_name: it.product_name,
                    regionalization: it.regionalization,
                    unit: it.unit,
                    quantity: 0,
                    total:0                  
                  }
                  allprods.push(newrprod)                
                }
                
              }else{
                if(!brockenpackages.includes(pk.id)){
                  console.log(`no category ${pk.id} - ${it.id}`)
                  brockenpackages.push(pk.id)
                  brokenpackages.push(pk)
                }
              }

            })

          }
        })

        var newloccats ={
          categories: cats,
          location: loc.id
        }
        var newlocprods ={
          products: prods,
          location: loc.id
        }
        
        locationProducts.push(newlocprods)        
        locationCategories.push(newloccats)  
      })   

      ////////////////////////////////////////

      if(brokenpackages.length >0){
        dispatch(fixbrockenpackages(brokenpackages))
      }else{
        var all_cat_total_object ={}
        var all_cat_quantity_object ={}
        var all_cat_total_grouped_loc =[]

        var all_product_total_object ={}
        var all_product_quantity_object ={}

        locations.map(loc=>{
          // console.log(loc)
          var itemtotal =0
          var shippingtotal =0
          var currentlocationCategory = locationCategories.filter(x=>loc.id == x.location)
          currentlocationCategory= currentlocationCategory[0]

          var  currentlocationProduct = locationProducts.filter(x=>loc.id == x.location)
          currentlocationProduct= currentlocationProduct[0]
  
          var cat_total_object ={}
          var cat_quantity_object ={}
          var product_total_object ={}
          var product_quantity_object ={}
          
          maindata.map(pk=>{
            
            if(pk.destination == loc.id){
              // console.log(pk)
      
              if(pk.shipping_fee){
                shippingtotal += parseFloat(pk.shipping_fee)
              }

              
                
              pk.items.map(it=>{
                if(it.quantity){               
                    var itemcost = 0
                    if(it.regionalization =='international'){
        
                      itemcost = (parseFloat(it.cost_rmb_adjusted) * parseFloat(it.quantity) * parseFloat(pk.exchange_rate))
                    }else{
                  
                      itemcost = (parseFloat(it.cost_peso) * parseFloat(it.quantity))
                    }
                  
                    itemtotal += itemcost
                    ///Catergory
                    if(cat_total_object?.[it.category]){
                      cat_total_object[it.category] += itemcost

                    }else{
                      cat_total_object[it.category] = itemcost
                    }
                    if(cat_quantity_object?.[it.category]){
                      cat_quantity_object[it.category] += parseFloat(it.quantity)

                    }else{
                      cat_quantity_object[it.category] = parseFloat(it.quantity)
                    }
                    if(all_cat_total_object?.[it.category]){
                      all_cat_total_object[it.category] += itemcost

                    }else{
                      all_cat_total_object[it.category] = itemcost
                    }
                    if(all_cat_quantity_object?.[it.category]){
                      all_cat_quantity_object[it.category] += parseFloat(it.quantity)

                    }else{
                      all_cat_quantity_object[it.category] = parseFloat(it.quantity)
                    }
                    ////Products
                    if(product_total_object?.[it.product]){
                      product_total_object[it.product] += itemcost

                    }else{
                      product_total_object[it.product] = itemcost
                    }
                    if(all_product_total_object?.[it.product]){
                      all_product_total_object[it.product] += itemcost

                    }else{
                      all_product_total_object[it.product] = itemcost
                    }
                    ////// Product Quantity
                    if(product_quantity_object?.[it.product]){
                      product_quantity_object[it.product] += parseFloat(it.quantity)

                    }else{
                      product_quantity_object[it.product] = parseFloat(it.quantity)
                    }
                    if(all_product_quantity_object?.[it.product]){
                      all_product_quantity_object[it.product] += parseFloat(it.quantity)

                    }else{
                      all_product_quantity_object[it.product] = parseFloat(it.quantity)
                    }

                  }                 
              })
            
            }
          })
          var categoriessum = currentlocationCategory.categories.map(ct=>{
            var catsum ={
              ...ct,
              total: parseFloat(cat_total_object[ct.cat_id]),
              quantity: parseFloat(cat_quantity_object[ct.cat_id]),
              category:ct.cat_name,
            }
            var catsum_loc={
              ...ct,
              total: parseFloat(cat_total_object[ct.cat_id]),
              quantity: parseFloat(cat_quantity_object[ct.cat_id]),
              category:ct.cat_name,
              loc_id:loc.id,
              loc_name:loc.name,
              commissary: loc.commissary,
            }
            all_cat_total_grouped_loc.push(catsum_loc)
            return(catsum)
          })
          
          var productsum = currentlocationProduct.products.map(prd=>{
            var prodsum ={
              ...prd,
              total: parseFloat(product_total_object[prd.product]),
              quantity: parseFloat(product_quantity_object[prd.product]),            
            }
            return(prodsum)
          })

       
          var locitem ={
            loc_id:loc.id,
            loc_name:loc.name,
            commissary: loc.commissary,
            itemtotal: itemtotal,
            shippingtotal:shippingtotal,
            categoriessum:categoriessum,

            productsum:productsum
          }


          var catsum_loc2={
         
            total: parseFloat(shippingtotal),
            cat_name:'Shipping',
            loc_id:loc.id,
            loc_name:loc.name,
            commissary: loc.commissary,
          }
          all_cat_total_grouped_loc.push(catsum_loc2)
          
          overallitemtotal += itemtotal
          overallshippingtotal+= shippingtotal
          newlocationspending.push(locitem)
        })   
      }

      var all_categoriessum = allcats.map(ct=>{
        var catsum ={
          ...ct,
          category:ct.cat_name,
          total:parseFloat( all_cat_total_object[ct.cat_id]),
          quantity:parseFloat( all_cat_quantity_object[ct.cat_id])
        }
        return(catsum)
      })

      var all_productsum = allprods.map(prd=>{
        var prodsum ={
          ...prd,
          value: parseFloat(all_product_total_object[prd.product]),
          total: parseFloat(all_product_total_object[prd.product]),
          quantity: parseFloat(all_product_quantity_object[prd.product]),            
        }
        return(prodsum)
      })
      
      console.log('product spending',all_productsum)
      setProductSpending(all_productsum)     
      // console.log('category spending',all_categoriessum)
      setCategorySpending(all_categoriessum)
      // console.log(overallitemtotal)
      setSumSpent(overallitemtotal)
      // console.log(overallshippingtotal)
      setShippingSpent(overallshippingtotal)
      // console.log('locationspending',newlocationspending)
      setLocationSpending(newlocationspending)
      console.log('all_cat_total_grouped_loc',all_cat_total_grouped_loc)
      setLocationSpendingGrouped_cat(all_cat_total_grouped_loc)
    }

    const renderProdcutsTable = (thisdata) =>{
      const columns = [
    
        {
          title: 'Category',
          dataIndex: 'category_name',
          defaultSortOrder: 'category_name',
          sorter: {
            compare: (a, b) => a.category_name.localeCompare(b.category_name), 
            multiple: 1    
          }, 
        },
            
        {
          title: 'Product',
          dataIndex: 'product_name',
          defaultSortOrder: 'product_name',
          sorter: {
            compare: (a, b) => a.product_name.localeCompare(b.product_name), 
            multiple: 1    
          }, 
        },
            
        {
          title: 'Regionalization',
          dataIndex: 'regionalization',
          defaultSortOrder: 'regionalization',
          sorter: {
            compare: (a, b) => a.regionalization.localeCompare(b.regionalization), 
            multiple: 1    
          }, 
        },
            
        ...(!hideMoney
          ? [
              {
                title: 'Total (Php)',
                dataIndex: 'total',
                defaultSortOrder: 'total',
                sorter: (a, b) => a.total - b.total,
                sortDirections: ['descend', 'ascend'],
                render: (text, record, index) =>{ 
                  return(`${numberWithCommas(text.toFixed(2))}`)
                }
              },
            ]
          : []),    
        {
          title: 'Quantity',
          dataIndex: 'quantity',
          defaultSortOrder: 'quantity',
    
          sorter: (a, b) => a.quantity - b.quantity,
          sortDirections: ['descend', 'ascend'],
        },
        {
          title: 'unit',
          dataIndex: 'unit',
          defaultSortOrder: 'unit',      
        },
  
      ];
      return(
        <Table columns={columns} dataSource={thisdata} size={'small'} className='thistable' 
          pagination={{
        
            pageSizeOptions:[25,50,100],
            defaultPageSize:25
 
          }}

          onRow={(record, rowIndex) => {
            return {
              onClick: event => {console.log(record)}, // click row
          
            };
        }}
        />
      )
    }

    const changeCategoryFilter = (e,loc) =>{
      var new_categoryFilter ={
        ...categoryFilter
      }
      new_categoryFilter[loc] = e
      setCategoryFilter(new_categoryFilter)
    }

    const changeSelectedCategory = (e,loc) =>{
      // var new_selectedCategory ={
      //   ...selectedCategory
      // }
      // new_selectedCategory[loc]=e
      setSelectedCategory(e)
    }

    const filteredthetable = (spending,loc)=>{
  
      if(selectedCategory){
        var ccat = selectedCategory

  
        var newspending = spending.filter(i => i.category == ccat.cat_id)
        return(newspending)
      }else{

        return(spending)
      }
    } 

    
    return(
      <div className='analytics_locations_container'> 
        {!hideMoney ? (
          <div className='stats'>
            <Statistic title="Total Items" value={sumSpent}  precision={2} prefix={'Php'}/>
            <Statistic title="Total Shipping" value={shippingSpent} precision={2}  prefix={'Php'} />
            <Statistic title="Total Spent" value={sumSpent + shippingSpent} precision={2}  prefix={'Php'} />
          </div>
        ) : null}

        {!hideMoney ? (
        <div>
         <Bar
          data={locationSpendingGrouped_cat}
          isStack={true}
          xField={'total'}
          yField={'cat_name'}
          seriesField={'loc_name'}
          tooltip={{
            formatter: (datum: Datum) => {
            
              return { name: datum.loc_name, value:` ${datum.total ? numberWithCommas(parseFloat(datum.total).toFixed(2)):0}` };
            }
          }}
          label={{
            formatter: (v) => {},
            // 可手动配置 label 数据标签位置
            position: 'middle',
            // 'left', 'middle', 'right'
            // 可配置附加的布局方法
            layout: [
              // 柱形图数据标签位置自动调整
              {
                type: 'interval-adjust-position',
              }, // 数据标签防遮挡
              {
                type: 'interval-hide-overlap',
              }, // 数据标签文颜色自动调整
              {
                type: 'adjust-color',
              },
            ]
          }}
         />
        </div>
        ) : null}
         
   
        <div className='mainoverall'>
          <div className='flex3 column'>
            <Title level={3} style={{marginTop:'1.5em' }}> 
            <div className='titlerow'>
              <span>Overall</span>   
              <div className='titlerow'>
              {selectedCategory? 
                <Button onClick={()=>{changeSelectedCategory(null,'overall') }}>Reset Table</Button>
              :null}    
              {!hideMoney ? <MainLocationsExport values={productspending} datePickerValue={datePickerValue} name={'Overall'} /> : null}
              </div>     
            </div>
            </Title>
            {renderProdcutsTable(filteredthetable(productspending,'overall'))}
          </div>
          <div className='flex1 paddingpie column'>
            <MainPie  currentData={categorySpending} 
                colorField={'category'}  angleField={hideMoney ? 'quantity' : 'total'} 
                onSelectedCategories={(e)=>{changeCategoryFilter(e,'overall')}}
                onCurrentSelectedCategory={(e)=>{changeSelectedCategory(e,'overall')}}
            />
            {selectedCategory ? 
            <MainPie  currentData={filteredthetable(productspending,'overall')} 
                colorField={'product_name'}  angleField={hideMoney ? 'quantity' : 'total'} 
             
            />
            :null
            }
            {/* {selectedCategory['overall'] ? 
            <MainPie  currentData={filteredthetable(productspending,'overall')} 
                colorField={'product_name'}  angleField={'quantity'} 
             
            />
            :null
            } */}

              
      
          </div>    
       
        </div>  
        <Title level={3} style={{marginTop:'1.5em' }}>Locations</Title>
        <List
          itemLayout="vertical"
          size="large"
          pagination={false}
          dataSource={locationSpending}
       
          renderItem={item => {
            console.log(item)
            if(!item.commissary){
            return(
            <List.Item
              key={item.loc_id}
              actions={[
                
              ]}
              extra={
                <div className='flex1 paddingpie column' >
                <MainPie  currentData={item.categoriessum} 
                  colorField={'category'}  angleField={hideMoney ? 'quantity' : 'total'} 
                  onSelectedCategories={(e)=>{changeCategoryFilter(e,item.loc_id)}}
                  onCurrentSelectedCategory={(e)=>{changeSelectedCategory(e,item.loc_id)}}
                />
                {selectedCategory ? 
                <MainPie  currentData={filteredthetable(item.productsum,item.loc_id)} 
                    colorField={'product_name'}  angleField={hideMoney ? 'quantity' : 'total'} 
                 
                />
                :null
                }
                {/* {selectedCategory[item.loc_id] ? 
                <MainPie  currentData={filteredthetable(productspending,item.loc_id)} 
                    colorField={'product_name'}  angleField={'quantity'} 
                 
                />
                :null
                } */}
                </div>
              }
            >
              <List.Item.Meta
                // avatar={<Avatar src={item.avatar} />}
                title={
                  <div className='titlerow'>
                    <span>{item.loc_name}</span>    
                    <div className='titlerow'>        
                    {selectedCategory ? 
                      <Button onClick={()=>{changeSelectedCategory(null,item.loc_id) }}>Reset Table</Button>
                    :null}  
                    {!hideMoney ? <MainLocationsExport values={item.productsum} datePickerValue={datePickerValue} name={item.loc_name}/> : null}
                    </div>
                  </div>
                }
                description={
                  !hideMoney ? <div className='stats'>
                     <Descriptions size={'small'}>
                      <Descriptions.Item label="Total Items">{`Php ${numberWithCommas(item.itemtotal.toFixed(2))}`}</Descriptions.Item>
                      <Descriptions.Item label="Total Shipping">{`Php ${numberWithCommas(item.shippingtotal.toFixed(2))}`}</Descriptions.Item>
                      <Descriptions.Item label="Total Spent">{`Php ${numberWithCommas((item.itemtotal + item.shippingtotal).toFixed(2))}`}</Descriptions.Item>
                    </Descriptions>
                   
                  </div> : null
                }
              />
                {renderProdcutsTable(filteredthetable(item.productsum,item.loc_id ))}
            </List.Item>
          )
          }}}

        />
    
      </div>
    )
}
  
export default Index
  
